import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'
import getHeadersformdata from './getHeaderFormdata'



export const TruChampAction = (params = {}) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.CREATE_TRUCHAMPS
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.url = url
  try {
    const response = await axios(options);
    if (response.status === 200 || response.status === 201) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    if (error.response) {
      if (error.response.status === 400) {
        const errorData = error.response.data.error;
        return error.response;
      } else {
        errorHandler(error);
      }
    } else {
      errorHandler(error);
    }
  }
};